<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" value="value">{{tipo.Nombre}} un tipo de despach</option>
        <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" value="value">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los tipos de despachos</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'

  export default {
    data() {
      return {
        enumeraciones
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/021TipoDespacho.vue